<template>
	<PopupRouterView :showLeftIcon="true" label="Role Management Input"  entityName="rolemanagement" :documentId="mainRecordId" :isBusy="isBusy || isDetailBusy" @saveMethod="saveAction" @hideMethod="onHidden">
		<b-card>
			<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Name" label-for="input-name" size="sm" :model.sync="model.name"  @change="updateData" />
				<app-input-textarea id="fieldset-description" label-cols-sm="4" label-cols-lg="3" label="Description" label-for="input-description" size="sm" :model.sync="model.description"  @change="updateData" />
			</b-col>
			<b-col>
				<span class="float-right" v-if="false">
					<b-button variant="success" class="float-right ml-2" @click="downloadData" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				</span>
			</b-col>
		</b-card>
	<b-card class="mt-3" header-bg-variant="transparent">
		<b-row class="mb-2">
			<b-col cols="9"><h5 class="card-title font-weight-bolder text-dark">Role Management Detail</h5></b-col>
			<b-col>
				<span class="float-right" v-if="false">
					<b-form-select v-model="roleManagementDetailPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
				</span>
			</b-col>
		</b-row>
		<b-row>
		<b-col>
			<div class="table-corner">
				<b-table
					id="my-table-2"
					:fields="fieldsRoleManagementDetail" 
					:items="roleManagementDetails"
					:per-page="perPage"
					:current-page="currentRoleManagementDetailPage"
					small
					>
						<template v-slot:head(actions)>
							<b-button @click="isShowRoleManagementDetailFilter = !isShowRoleManagementDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
						</template>
						<template #top-row v-if="isShowRoleManagementDetailFilter">
							<b-th></b-th>
							<b-th stacked-heading="Function Info">
								<v-select append-to-body label="name" :options="functionInfoFilters" :value="filterRoleManagementDetail.functionInfoId" :reduce="item => item.id" v-model="filterRoleManagementDetail.functionInfoId" :filterable ="true" @input="getFunctionInfoFilters" @search="getFunctionInfoFilters" ></v-select>
							</b-th>
							<b-th stacked-heading="Allow Create">
								<b-form-checkbox v-if="false" id="input-allow-create-table" class="float-right" v-model="filterRoleManagementDetail.allowCreate"></b-form-checkbox>
							</b-th>
							<b-th stacked-heading="Allow Read">
								<b-form-checkbox v-if="false" id="input-allow-read-table" class="float-right" v-model="filterRoleManagementDetail.allowRead"></b-form-checkbox>
							</b-th>
							<b-th stacked-heading="Allow Update">
								<b-form-checkbox v-if="false" id="input-allow-update-table" class="float-right" v-model="filterRoleManagementDetail.allowUpdate"></b-form-checkbox>
							</b-th>
							<b-th stacked-heading="Allow Delete">
								<b-form-checkbox v-if="false" id="input-allow-delete-table" class="float-right" v-model="filterRoleManagementDetail.allowDelete"></b-form-checkbox>
							</b-th>
							<b-th stacked-heading="Show In Menu">
								<b-form-checkbox v-if="false" id="input-show-in-menu-table" class="float-right" v-model="filterRoleManagementDetail.showInMenu"></b-form-checkbox>
							</b-th>
							<b-th stacked-heading="Allow Download">
								<b-form-checkbox v-if="false" id="input-allow-download-table" class="float-right" v-model="filterRoleManagementDetail.allowDownload"></b-form-checkbox>
							</b-th>
							<b-th stacked-heading="Allow Print">
								<b-form-checkbox v-if="false" id="input-allow-print-table" class="float-right" v-model="filterRoleManagementDetail.allowPrint"></b-form-checkbox>
							</b-th>
							<b-th stacked-heading="Allow Upload">
								<b-form-checkbox v-if="false" id="input-allow-upload-table" class="float-right" v-model="filterRoleManagementDetail.allowUpload"></b-form-checkbox>
							</b-th> 
							<b-th>
							</b-th>
						</template>
						<template v-slot:cell(no)="row">
							{{ ((row.index + 1) + ( roleManagementDetailPageSize * (currentRoleManagementDetailPage - 1))) }}
						</template>
						<template v-slot:table-busys>
							<div class="text-center my-2">
						<b-spinner class="align-middle text-primary"></b-spinner>
							<strong class="ml-2">Loading...</strong>
							</div>
						</template>
						<template v-slot:cell(functionInfo)="row">
							<app-input-combobox-autocomplete :options="functionInfos" optionsLabel="name" optionsKey="id" id="input-" size="sm" :model.sync="row.item.functionInfoId" onSelectMethod="setSelectedFunctionInfo" :selected="row.item.functionInfoName" @change="setFunctionInfo(row.item)" @input="getFunctionInfos" @search="getFunctionInfos" />
						</template>
						<template v-slot:cell(allowCreate)="row">
							<b-form-checkbox :id="'input-allow-create-' + row.index" v-model="row.item.allowCreate"  @change="saveInputRoleManagementDetail(row.item)"></b-form-checkbox>
						</template>
						<template v-slot:cell(allowRead)="row">
							<b-form-checkbox :id="'input-allow-read-' + row.index" v-model="row.item.allowRead"  @change="saveInputRoleManagementDetail(row.item)"></b-form-checkbox>
						</template>
						<template v-slot:cell(allowUpdate)="row">
							<b-form-checkbox :id="'input-allow-update-' + row.index" v-model="row.item.allowUpdate"  @change="saveInputRoleManagementDetail(row.item)"></b-form-checkbox>
						</template>
						<template v-slot:cell(allowDelete)="row">
							<b-form-checkbox :id="'input-allow-delete-' + row.index" v-model="row.item.allowDelete"  @change="saveInputRoleManagementDetail(row.item)"></b-form-checkbox>
						</template>
						<template v-slot:cell(showInMenu)="row">
							<b-form-checkbox :id="'input-show-in-menu-' + row.index" v-model="row.item.showInMenu"  @change="saveInputRoleManagementDetail(row.item)"></b-form-checkbox>
						</template>
						<template v-slot:cell(allowDownload)="row">
							<b-form-checkbox :id="'input-allow-download-' + row.index" v-model="row.item.allowDownload"  @change="saveInputRoleManagementDetail(row.item)"></b-form-checkbox>
						</template>
						<template v-slot:cell(allowPrint)="row">
							<b-form-checkbox :id="'input-allow-print-' + row.index" v-model="row.item.allowPrint"  @change="saveInputRoleManagementDetail(row.item)"></b-form-checkbox>
						</template>
						<template v-slot:cell(allowUpload)="row">
							<b-form-checkbox :id="'input-allow-upload-' + row.index" v-model="row.item.allowUpload"  @change="saveInputRoleManagementDetail(row.item)"></b-form-checkbox>
						</template>
						<template v-slot:cell(actions)="row">
							<div class="div-actions">
								<b-overlay
									rounded
									opacity="0.6"
									spinner-small
									spinner-variant="primary"
									class="d-inline-block"
								>
									<click-confirm>
										<b-button size="sm" variant="danger" @click="deleteRowDataRoleManagementDetail(row)" class="mr-2 btn-xs">
										<b-icon-trash></b-icon-trash>
										</b-button>
									</click-confirm>
								</b-overlay>	
							</div>
						</template>
					</b-table>
				</div>
				<b-row>
					<b-col cols="12" lg="8">
						<b-button variant="success" size="sm" @click="addDataRoleManagementDetail"><b-icon-plus></b-icon-plus> Tambah</b-button>
					</b-col>
					<b-col cols="12" lg="4">
						<div class="float-lg-right mt-3 mt-lg-0">
						<b-pagination
							v-model="currentRoleManagementDetailPage"
							:total-rows="rows"
							:per-page="perPage"
							aria-controls="my-table-2"
							></b-pagination>
						</div>
					</b-col>
				</b-row>
		</b-col>
		</b-row>
	</b-card>

	<b-overlay :show="isBusy || isDetailBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import RoleManagement from '@/models/RoleManagement/RoleManagement';
import RoleManagementList from '@/models/RoleManagement/RoleManagementList';
import RoleManagementFilter from '@/filters/RoleManagement/RoleManagementFilter';

import PopupConfirmationDetail from './PopupConfirmationDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import RoleManagementDetail from '@/models/RoleManagement/RoleManagementDetail';
import RoleManagementDetailFilter from '@/filters/RoleManagement/RoleManagementDetailFilter';
import FunctionInfo from '@/models/Core/FunctionInfoAPI';
import FunctionInfoFilter from '@/filters/Core/FunctionInfoFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import RoleManagementDetailInput from '@/views/RoleManagement/RoleManagementDetailInput';
import RoleManagementDetailUpload from '@/views/RoleManagement/RoleManagementDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {AppInputComboboxAutocomplete,AppInputTextbox,AppInputTextarea,RoleManagementDetailInput,RoleManagementDetailUpload,AppTableInput,AppTableInputPopup,PopupRouterView,PopupConfirmationDetail},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsRoleManagementDetail: [
				{"no" : { "class" : "th-number"}}, 
				{"functionInfo": { "class" : "th-function-info"}, "label" : "Function Info", key: 'functionInfo'}, 
				{"allowCreate": { "class" : "th-allow-create"}, "label" : "Allow Create", key: 'allowCreate'}, 
				{"allowRead": { "class" : "th-allow-read"}, "label" : "Allow Read", key: 'allowRead'}, 
				{"allowUpdate": { "class" : "th-allow-update"}, "label" : "Allow Update", key: 'allowUpdate'}, 
				{"allowDelete": { "class" : "th-allow-delete"}, "label" : "Allow Delete", key: 'allowDelete'}, 
				{"showInMenu": { "class" : "th-show-in-menu"}, "label" : "Show In Menu", key: 'showInMenu'}, 
				{"allowDownload": { "class" : "th-allow-download"}, "label" : "Allow Download", key: 'allowDownload'}, 
				{"allowPrint": { "class" : "th-allow-print"}, "label" : "Allow Print", key: 'allowPrint'}, 
				{"allowUpload": { "class" : "th-allow-upload"}, "label" : "Allow Upload", key: 'allowUpload'}, 
				{"actions": { "class" : "th-actions", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDetailBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelRoleManagementDetail : {},
			isShowPopupRoleManagementDetail : false,
			isShowPopupUploadRoleManagementDetail : false,
			filterRoleManagement : null,
			currentRoleManagementPage : 1,
			roleManagementPageSize: 10,
			sortByRoleManagement: '',
			sortDescRoleManagement: '',
			filterRoleManagementDetail : null,
			currentRoleManagementDetailPage : 1,
			roleManagementDetailPageSize: 10,
			sortByRoleManagementDetail: '',
			sortDescRoleManagementDetail: '',
			sortingByRoleManagementDetail: [],
			roleManagementDetails : [],
			tempRoleManagementDetails : [],
			roleManagementDetailId : '',
			totalRoleManagementDetailRow : 0,
			isShowRoleManagementDetailFilter: false,
			isDownloadRoleManagementDetail: false,
			functionInfos: [],
			functionInfoFilters: [],
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			readyToSave: [],
			unwatch : null,
			perPage: 10,
			currentPage: 1,
			items: [
				{ id: 1, first_name: 'Fred', last_name: 'Flintstone' },
				{ id: 2, first_name: 'Wilma', last_name: 'Flintstone' },
				{ id: 3, first_name: 'Barney', last_name: 'Rubble' },
				{ id: 4, first_name: 'Betty', last_name: 'Rubble' },
				{ id: 5, first_name: 'Pebbles', last_name: 'Flintstone' },
				{ id: 6, first_name: 'Bamm Bamm', last_name: 'Rubble' },
				{ id: 7, first_name: 'The Great', last_name: 'Gazzoo' },
				{ id: 8, first_name: 'Rockhead', last_name: 'Slate' },
				{ id: 9, first_name: 'Pearl', last_name: 'Slaghoople' },
				{ id: 10, first_name: 'Pearl 1', last_name: 'Slaghoop22le' },
				{ id: 19, first_name: 'Pearl 2 ', last_name: 'Slaghoople22' },
				{ id: 29, first_name: 'Pearl3 ', last_name: 'Slaghoop22le' }

				]
		}
	},
	methods : {
		getRoleManagement : async function(id) {
			this.isBusy = true;
			RoleManagement.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadRoleManagement = true;
			this.filterRoleManagement.id = this.modelId;
			RoleManagement.downloadDataDetail(this, this.filterRoleManagement).then(result => {
				this.isDownloadRoleManagement = false;
			}).catch(error => { this.isDownloadRoleManagement = false; })
		},
		getRoleManagementDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterRoleManagementDetail);
			if (this.modelId == null) return;
			filter.roleManagementId = this.modelId;
			//filter.draftMode = "1";
			if (this.sortByRoleManagementDetail != null) {
				this.sortingByRoleManagementDetail[this.sortByRoleManagementDetail] = this.sortDescRoleManagementDetail;
			}
			let currentPage = (this.currentRoleManagementDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalRoleManagementDetailRow + 1;
				let page = Math.ceil(totalData/this.roleManagementDetailPageSize);
				currentPage = page - 1;
			}
			this.isDetailBusy = true;
			if (this.modelId != null && this.modelId != "") {
				RoleManagementDetail.getList(this, filter, this.sortingByRoleManagementDetail, 0, 0).then(result => {
					this.currentRoleManagementDetailPage = currentPage + 1;
					this.roleManagementDetails = result.data;
					this.tempRoleManagementDetails = result.data;
					this.totalRoleManagementDetailRow = result.dataCount;
					this.isDetailBusy = false;
				}).catch(error => {
					this.isDetailBusy = false;
				});
			}
		},
		getRoleManagements : async function(input) {
			let filter = new RoleManagementFilter();
			if (input != undefined) {
				filter.name = input;
			}
			RoleManagement.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.roleManagements = result.data
				}
			})
			.catch(error => {});
		},
		getFunctionInfos : async function(input) {
			let filter = new FunctionInfoFilter();
			if (input != undefined) {
				filter.name = input;
			}
			FunctionInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.functionInfos = result.data
				}
			})
			.catch(error => {});
		},
		getFunctionInfoFilters : async function(input) {
			let filter = new FunctionInfoFilter();
			if (input != undefined) {
				filter.name = input;
			}
			FunctionInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.functionInfoFilters = result.data
				}
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		
		saveActionConfirmation(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				if (this.readyToSave.length > 0) {
					this.unwatch = this.$watch('readyToSave', function (newVal, oldVal) {
						if (newVal.length == 0) {
							this.isBusy = false;
							this.isShowPopupConfirmation = false;
							this.saveAction(modalEvent);
							this.unwatch();
						}
					
					});
				} else {
					this.isBusy = false;
					this.isShowPopupConfirmation = false;
					this.saveAction(modalEvent);
				}
			}
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			let id = this.modelId;
			let model = this.model;

			if (this.$v.model.$anyError) {
				return;
			}

			if (id != '' && id != null && id != undefined) {
				let filter = this.filterRoleManagementDetail;
				if (filter.functionInfoId != null && filter.functionInfoId != "") {
					this.roleManagementDetails = this.tempRoleManagementDetails;
				}

				let roleManagementDetails = this.roleManagementDetails.map(a => Object.assign({}, a));
				
				if (roleManagementDetails.length > 0) {
					roleManagementDetails.forEach(item => {
						delete item.functionInfo;
						delete item.roleManagement;
					})
				}
				
				model.roleManagementDetail = roleManagementDetails;

				RoleManagement.updateDataDetail(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$router.push({ name: 'rolemanagementindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			} else {
				model.roleManagementDetail = this.roleManagementDetails;
				RoleManagement.insertData(this, model).then(result => {
					this.$router.push({ name: 'rolemanagementindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;

			let promises = Array();

			this.readyToSave.push(1);
			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					RoleManagement.updateData(this, model, id)
					.then(e=>{
						this.readyToSave.pop();
					})
					.catch(e=>{
						this.readyToSave.pop();
					});
				}
			});
			return;
		},
		onHidden() {
			this.getRoleManagements();
		},
		addRowDataRoleManagementDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.roleManagementId =  this.modelId;
					RoleManagementDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getRoleManagementDetails(true);
						this.isShowPopupRoleManagementDetail = false;
					})
				} else {
					model.roleManagementId =  this.modelId;
					RoleManagementDetail.createDataDetail(this, model)
					.then(result => {
						this.getRoleManagementDetails(true);
						this.isShowPopupRoleManagementDetail = false;
					})
				}
			}
		},
		async editRowDataRoleManagementDetail(id) {
			this.roleManagementDetailId = id;
			this.isShowPopupRoleManagementDetail = true; 
		},
		async deleteRowDataRoleManagementDetail(row) {
			let index = ((this.currentRoleManagementDetailPage - 1) * this.roleManagementDetailPageSize) + row.index;
			if (this.roleManagementDetails.length > 0) {
				this.roleManagementDetails.splice(index, 1);
			}
			//RoleManagementDetail.deleteData(this, id).then(result => { this.getRoleManagementDetails(); });
		},
		async resetDataRoleManagementDetail() {
			this.roleManagementDetailId = "";
			this.isShowPopupRoleManagementDetail = true;
		},
		async addDataRoleManagementDetail() {
			this.roleManagementDetails.push({});
			/*RoleManagementDetail.createDataDetail(this, { roleManagementId: this.modelId })
			.then(result => {
				this.getRoleManagementDetails(true);
			});*/
		},
		async addFromClipboardRoleManagementDetail() {
			let roleManagements = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					roleManagements.push({ roleManagement: item, roleManagementId: this.modelId });
				});
				RoleManagementDetail.addFromClipboard(this, roleManagements).then(result => { this.getRoleManagementDetails() });
			});
		},
		async replaceFromClipboardRoleManagementDetail() {
			let roleManagements = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					roleManagements.push({ roleManagement: item, roleManagementId: this.modelId });
				});
				RoleManagementDetail.replaceFromClipboard(this, roleManagements).then(result => { this.getRoleManagementDetails() });
			});   
		},
		showPopupUploadRoleManagementDetail() {
			this.isShowPopupUploadRoleManagementDetail = true;
		},
		uploadDataRoleManagementDetail(modalEvent, newDatas) {
			this.isShowPopupUploadRoleManagementDetail = false; 
		},
		downloadRoleManagementDetail(modalEvent) {
			this.isDownloadRoleManagementDetail = true;
			this.filterRoleManagementDetail.roleManagementId = this.modelId;
			RoleManagementDetail.downloadDataDetail(this, this.filterRoleManagementDetail).then(result => {
				this.isDownloadRoleManagementDetail = false;
			}).catch(error => { this.isDownloadRoleManagementDetail = false; })
		},
		saveInputRoleManagementDetail(item) {
			return;
			if (item.id) {
				RoleManagementDetail.updateDataDetail(this, item, item.id);
			}
		},
		resetModal(modalType) {
			this.isShowPopupUploadRoleManagementDetail = false; 
			this.isShowPopupRoleManagementDetail = false; 
			if (modalType == 'RoleManagementDetail') {
				this.getRoleManagementDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowRoleManagementDetailFilter = true;
			}
		},
		setSelectedFunctionInfo(item) {
			let functionInfoObj = this.functionInfos.filter(function(functionInfo){ return functionInfo.id == item.functionInfoId; });
			item.functionInfo = functionInfoObj.length > 0 ? functionInfoObj[0] : null;
		},
		setFunctionInfo(item) {
			console.log(item);
			if (item.functionInfo != null) {

			}
		}
	},
	beforeMount() {
		this.filterRoleManagement = new RoleManagementFilter();
		this.filterRoleManagementDetail = new RoleManagementDetailFilter();
		this.getFunctionInfos();
		this.getFunctionInfoFilters();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getRoleManagement(id);
				this.getRoleManagementDetails();
			} else {
				this.modelId = id;
				this.getRoleManagement(id);
				this.getRoleManagementDetails();
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		rows() {
			return this.roleManagementDetails.length
		}
	},
	watch : {
		sortByRoleManagementDetail : {
			handler: function() {
				this.getRoleManagementDetails();
			}
		},
		sortDescRoleManagementDetail: {
			handler: function() {
				this.getRoleManagementDetails();
			}
		},
		currentRoleManagementDetailPage: {
			handler: function() {
				//this.getRoleManagementDetails();
			}
		},
		roleManagementDetailPageSize : {
			handler: function() {
				this.getRoleManagementDetails();
			}
		},
		filterRoleManagementDetail: {
			handler: function(newVal) {
				console.log(newVal);
				if (newVal.functionInfoId != null && newVal.functionInfoId != "") {
					this.roleManagementDetails = this.roleManagementDetails.filter(function (el) {
						return el.functionInfoId == newVal.functionInfoId;
					});
				} else {
					this.roleManagementDetails = this.tempRoleManagementDetails;	
				}
				//this.getRoleManagementDetails();
			},
			deep: true,
		},
	},
	beforeDestroy() {
		if (!this.isDataCommited) {
			//RoleManagement.discardData(this, this.modelId);
		}
	},
}
</script>
